<div class="welcome">

  <app-icon
    class="welcome__close"
    icon="times"
    size="lg"
    title="Close"
    (click)="handleCloseTour()">
  </app-icon>

  <div class="slide">
    <!-- slides -->
    <div
      *ngFor="let slide of slides;let i = index"
      class="slide__item"        
      [class.slide__item--hidden]="selectedIndex !== i">
        <img
          *ngIf="slide.logo"
          class="slide__logo"
          [src]="slide.logo">  
        <div
          *ngIf="slide.title"
          class="text-24 text-medium text-uppercase mt-4">
          {{ slide.title }}
        </div>
        <div
          *ngIf="slide.text"
          class="text-18 mt-4 mb-4"
          [class.text-22]="slide.logo"
          [class.text-medium]="slide.logo" 
          [innerHTML]="slide.text">
        </div>
        <img
          *ngIf="slide.image"
          class="slide__image"
          [src]="slide.image">        
    </div>

    <!-- nav -->
    <div class="slide__nav">
        <app-icon
          class="slide__nav-arrow"
          [class.slide__nav-arrow--disabled]="isFirstSlide"
          icon="chevron-left"            
          (click)="handlePrevClick()">
        </app-icon>

        <!-- dots -->
        <div class="slide__nav-dots">
          <div
            class="slide__nav-dot"
            [class.slide__nav-dot--active]="selectedIndex === i"
            [attr.title]="slide.title"
            *ngFor="let slide of slides;let i = index"
            (click)="handleSelectSlideClick(i)">
          </div>
        </div>
        
        <app-icon
          class="slide__nav-arrow"
          [class.slide__nav-arrow--disabled]="isLastSlide"
          icon="chevron-right"            
          (click)="handleNextClick()">
        </app-icon>
    </div>
  </div>
</div>